import { Nav } from 'react-bootstrap';
import React,{ Component} from 'react';
import {Button,NavDropdown,Navbar} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Node from './Node/Node';
import {dijkstra} from '../algorithms/dijkstra';
import {AStar} from '../algorithms/aStar';
import {dfs} from '../algorithms/dfs';
import {bfs} from '../algorithms/bfs';

import './PathfindingVisualizer.css';



export default class PathfindingVisualizer extends Component {
    constructor() {
      super();
      this.state = {
        grid: [],
        START_NODE_ROW: 10,
        FINISH_NODE_ROW: 10,
        START_NODE_COL: 18,
        FINISH_NODE_COL: 35,
        mouseIsPressed: false,
        ROW_COUNT: 21,
        COLUMN_COUNT: 54,
        MOBILE_ROW_COUNT: 10,
        MOBILE_COLUMN_COUNT: 20,
        isRunning: false,
        isStartNode: false,
        isFinishNode: false,
        isWallNode: false, // xxxxxxx
        currRow: 0,
        currCol: 0,
        isDesktopView: true,
      };
  
      this.handleMouseDown = this.handleMouseDown.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.toggleIsRunning = this.toggleIsRunning.bind(this);
    }
  
    componentDidMount() {
      const grid = this.getInitialGrid();
      this.setState({grid});
    }
  
    toggleIsRunning() {
      this.setState({isRunning: !this.state.isRunning});
    }
  
    toggleView() {
      if (!this.state.isRunning) {
        this.clearGrid();
        this.clearWalls();
        const isDesktopView = !this.state.isDesktopView;
        let grid;
        if (isDesktopView) {
          grid = this.getInitialGrid(
            this.state.ROW_COUNT,
            this.state.COLUMN_COUNT,
          );
          this.setState({isDesktopView, grid});
        } else {
          if (
            this.state.START_NODE_ROW > this.state.MOBILE_ROW_COUNT ||
            this.state.FINISH_NODE_ROW > this.state.MOBILE_ROW_COUNT ||
            this.state.START_NODE_COL > this.state.MOBILE_COLUMN_COUNT ||
            this.state.FINISH_NODE_COL > this.state.MOBILE_COLUMN_COUNT
          ) {
            alert('Start & Finish Nodes Must Be within 10 Rows x 20 Columns');
          } else {
            grid = this.getInitialGrid(
              this.state.MOBILE_ROW_COUNT,
              this.state.MOBILE_COLUMN_COUNT,
            );
            this.setState({isDesktopView, grid});
          }
        }
      }
    }
  
    /******************** Set up the initial grid ********************/
    getInitialGrid = (
      rowCount = this.state.ROW_COUNT,
      colCount = this.state.COLUMN_COUNT,
    ) => {
      const initialGrid = [];
      for (let row = 0; row < rowCount; row++) {
        const currentRow = [];
        for (let col = 0; col < colCount; col++) {
          currentRow.push(this.createNode(row, col));
        }
        initialGrid.push(currentRow);
      }
      return initialGrid;
    };
  
    createNode = (row, col) => {
      return {
        row,
        col,
        isStart:
          row === this.state.START_NODE_ROW && col === this.state.START_NODE_COL,
        isFinish:
          row === this.state.FINISH_NODE_ROW &&
          col === this.state.FINISH_NODE_COL,
        distance: Infinity,
        distanceToFinishNode:
          Math.abs(this.state.FINISH_NODE_ROW - row) +
          Math.abs(this.state.FINISH_NODE_COL - col),
        isVisited: false,
        isWall: false,
        previousNode: null,
        isNode: true,
      };
    };
  
    /******************** Control mouse events ********************/
    handleMouseDown(row, col) {
      if (!this.state.isRunning) {
        if (this.isGridClear()) {
          if (
            document.getElementById(`node-${row}-${col}`).className ===
            'node node-start'
          ) {
            this.setState({
              mouseIsPressed: true,
              isStartNode: true,
              currRow: row,
              currCol: col,
            });
          } else if (
            document.getElementById(`node-${row}-${col}`).className ===
            'node node-finish'
          ) {
            this.setState({
              mouseIsPressed: true,
              isFinishNode: true,
              currRow: row,
              currCol: col,
            });
          } else {
            const newGrid = getNewGridWithWallToggled(this.state.grid, row, col);
            this.setState({
              grid: newGrid,
              mouseIsPressed: true,
              isWallNode: true,
              currRow: row,
              currCol: col,
            });
          }
        } else {
          this.clearGrid();
        }
      }
    }
  
    isGridClear() {
      for (const row of this.state.grid) {
        for (const node of row) {
          const nodeClassName = document.getElementById(
            `node-${node.row}-${node.col}`,
          ).className;
          if (
            nodeClassName === 'node node-visited' ||
            nodeClassName === 'node node-shortest-path'
          ) {
            return false;
          }
        }
      }
      return true;
    }
  
    handleMouseEnter(row, col) {
      if (!this.state.isRunning) {
        if (this.state.mouseIsPressed) {
          const nodeClassName = document.getElementById(`node-${row}-${col}`)
            .className;
          if (this.state.isStartNode) {
            if (nodeClassName !== 'node node-wall') {
              const prevStartNode = this.state.grid[this.state.currRow][
                this.state.currCol
              ];
              prevStartNode.isStart = false;
              document.getElementById(
                `node-${this.state.currRow}-${this.state.currCol}`,
              ).className = 'node';
  
              this.setState({currRow: row, currCol: col});
              const currStartNode = this.state.grid[row][col];
              currStartNode.isStart = true;
              document.getElementById(`node-${row}-${col}`).className =
                'node node-start';
            }
            this.setState({START_NODE_ROW: row, START_NODE_COL: col});
          } else if (this.state.isFinishNode) {
            if (nodeClassName !== 'node node-wall') {
              const prevFinishNode = this.state.grid[this.state.currRow][
                this.state.currCol
              ];
              prevFinishNode.isFinish = false;
              document.getElementById(
                `node-${this.state.currRow}-${this.state.currCol}`,
              ).className = 'node';
  
              this.setState({currRow: row, currCol: col});
              const currFinishNode = this.state.grid[row][col];
              currFinishNode.isFinish = true;
              document.getElementById(`node-${row}-${col}`).className =
                'node node-finish';
            }
            this.setState({FINISH_NODE_ROW: row, FINISH_NODE_COL: col});
          } else if (this.state.isWallNode) {
            const newGrid = getNewGridWithWallToggled(this.state.grid, row, col);
            this.setState({grid: newGrid});
          }
        }
      }
    }
  
    handleMouseUp(row, col) {
      if (!this.state.isRunning) {
        this.setState({mouseIsPressed: false});
        if (this.state.isStartNode) {
          const isStartNode = !this.state.isStartNode;
          this.setState({isStartNode, START_NODE_ROW: row, START_NODE_COL: col});
        } else if (this.state.isFinishNode) {
          const isFinishNode = !this.state.isFinishNode;
          this.setState({
            isFinishNode,
            FINISH_NODE_ROW: row,
            FINISH_NODE_COL: col,
          });
        }
        this.getInitialGrid();
      }
    }
  
    handleMouseLeave() {
      if (this.state.isStartNode) {
        const isStartNode = !this.state.isStartNode;
        this.setState({isStartNode, mouseIsPressed: false});
      } else if (this.state.isFinishNode) {
        const isFinishNode = !this.state.isFinishNode;
        this.setState({isFinishNode, mouseIsPressed: false});
      } else if (this.state.isWallNode) {
        const isWallNode = !this.state.isWallNode;
        this.setState({isWallNode, mouseIsPressed: false});
        this.getInitialGrid();
      }
    }
  
    /******************** Clear Board/Walls ********************/
  
    clearGrid() {
      if (!this.state.isRunning) {
        const newGrid = this.state.grid.slice();
        for (const row of newGrid) {
          for (const node of row) {
            let nodeClassName = document.getElementById(
              `node-${node.row}-${node.col}`,
            ).className;
            if (
              nodeClassName !== 'node node-start' &&
              nodeClassName !== 'node node-finish' &&
              nodeClassName !== 'node node-wall'
            ) {
              document.getElementById(`node-${node.row}-${node.col}`).className =
                'node';
              node.isVisited = false;
              node.distance = Infinity;
              node.distanceToFinishNode =
                Math.abs(this.state.FINISH_NODE_ROW - node.row) +
                Math.abs(this.state.FINISH_NODE_COL - node.col);
            }
            if (nodeClassName === 'node node-finish') {
              node.isVisited = false;
              node.distance = Infinity;
              node.distanceToFinishNode = 0;
            }
            if (nodeClassName === 'node node-start') {
              node.isVisited = false;
              node.distance = Infinity;
              node.distanceToFinishNode =
                Math.abs(this.state.FINISH_NODE_ROW - node.row) +
                Math.abs(this.state.FINISH_NODE_COL - node.col);
              node.isStart = true;
              node.isWall = false;
              node.previousNode = null;
              node.isNode = true;
            }
          }
        }
      }
    }
  
    clearWalls() {
      if (!this.state.isRunning) {
        const newGrid = this.state.grid.slice();
        for (const row of newGrid) {
          for (const node of row) {
            let nodeClassName = document.getElementById(
              `node-${node.row}-${node.col}`,
            ).className;
            if (nodeClassName === 'node node-wall') {
              document.getElementById(`node-${node.row}-${node.col}`).className =
                'node';
              node.isWall = false;
            }
          }
        }
      }
    }

    /******************** Create Animations ********************/
    visualize(algo) {
      if (!this.state.isRunning) {
        this.clearGrid();
        this.toggleIsRunning();
        const {grid} = this.state;
        const startNode =
          grid[this.state.START_NODE_ROW][this.state.START_NODE_COL];
        const finishNode =
          grid[this.state.FINISH_NODE_ROW][this.state.FINISH_NODE_COL];
        let visitedNodesInOrder;
        switch (algo) {
          case 'Dijkstra':
            visitedNodesInOrder = dijkstra(grid, startNode, finishNode);
            break;
          case 'AStar':
            visitedNodesInOrder = AStar(grid, startNode, finishNode);
            break;
          case 'BFS':
            visitedNodesInOrder = bfs(grid, startNode, finishNode);
            break;
          case 'DFS':
            visitedNodesInOrder = dfs(grid, startNode, finishNode);
            break;
          default:
            // should never get here
            break;
        }
        const nodesInShortestPathOrder = getNodesInShortestPathOrder(finishNode);
        nodesInShortestPathOrder.push('end');
        this.animate(visitedNodesInOrder, nodesInShortestPathOrder);
      }
    }
  
    animate(visitedNodesInOrder, nodesInShortestPathOrder) {
      for (let i = 0; i <= visitedNodesInOrder.length; i++) {
        if (i === visitedNodesInOrder.length) {
          setTimeout(() => {
            this.animateShortestPath(nodesInShortestPathOrder);
          }, 10 * i);
          return;
        }
        setTimeout(() => {
          const node = visitedNodesInOrder[i];
          const nodeClassName = document.getElementById(
            `node-${node.row}-${node.col}`,
          ).className;
          if (
            nodeClassName !== 'node node-start' &&
            nodeClassName !== 'node node-finish'
          ) {
            document.getElementById(`node-${node.row}-${node.col}`).className =
              'node node-visited';
          }
        }, 10 * i);
      }
    }
  
    /******************** Create path from start to finish ********************/
    animateShortestPath(nodesInShortestPathOrder) {
      for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
        if (nodesInShortestPathOrder[i] === 'end') {
          setTimeout(() => {
            this.toggleIsRunning();
          }, i * 50);
        } else {
          setTimeout(() => {
            const node = nodesInShortestPathOrder[i];
            const nodeClassName = document.getElementById(
              `node-${node.row}-${node.col}`,
            ).className;
            if (
              nodeClassName !== 'node node-start' &&
              nodeClassName !== 'node node-finish'
            ) {
              document.getElementById(`node-${node.row}-${node.col}`).className =
                'node node-shortest-path';
            }
          }, i * 40);
        }
      }
    }
  
    render(){
        const {grid, mouseIsPressed} = this.state;
        return(
        <>    
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light" >
            <Navbar.Brand href="#home"><b>Pathfinding Visualizer</b></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav" style={{paddingLeft:"17em"}}>
                <Nav className="mr-auto">
                    <Nav.Link href="#" style={{paddingRight:"2em"}}><button type="button" class="btn btn-outline-info" data-toggle="button" aria-pressed="false"  onClick={() => this.visualize('AStar')}>A*algo</button></Nav.Link>
                    <Nav.Link href="#" style={{paddingRight:"2em"}} ><button type="button" class="btn btn-outline-success" data-toggle="button" aria-pressed="false"  onClick={() => this.clearGrid()}>Clear Grid</button></Nav.Link>
                    <Nav.Link href="#" style={{paddingRight:"2em"}}><button type="button" class="btn btn-outline-dark" data-toggle="button" aria-pressed="false"  onClick={() => this.clearWalls()}>Clear Walls</button></Nav.Link>    
                </Nav> 
            </Navbar.Collapse>
        </Navbar>

        <div class="d-flex flex-row flex-wrap m-2 justify-content-around">	
 		<div class="d-flex p-2">
 			<div class="key wall"></div>  
 			<div> Wall</div>
 		</div>
 		<div class="d-flex p-2">
 			<div class="key start"></div>  
 			<div>Start</div>
 		</div>
 		<div class="d-flex p-2">
 			<div class="key end"></div>  
 			<div>Target</div>
 		</div>
 		<div class="d-flex p-2">  
 			<div class="key visited"></div>  
 			<div>Visited</div>
 		</div>
 		<div class="d-flex p-2">
 			<div class="key success"></div>  
 			<div>Shortest-Path</div>
 		</div>
 		<div class="d-flex p-2">
 			<div class="key"></div>  
 			<div>Unvisited</div>
 		</div>
 	</div>
      
        
        <table
          className="grid-container"
          onMouseLeave={() => this.handleMouseLeave()}>
          <tbody className="grid">
            {grid.map((row, rowIdx) => {
              return (
                <tr key={rowIdx}>
                  {row.map((node, nodeIdx) => {
                    const {row, col, isFinish, isStart, isWall} = node;
                    return (
                      <Node
                        key={nodeIdx}
                        col={col}
                        isFinish={isFinish}
                        isStart={isStart}
                        isWall={isWall}
                        mouseIsPressed={mouseIsPressed}
                        onMouseDown={(row, col) =>
                          this.handleMouseDown(row, col)
                        }
                        onMouseEnter={(row, col) =>
                          this.handleMouseEnter(row, col)
                        }
                        onMouseUp={() => this.handleMouseUp(row, col)}
                        row={row}></Node>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        </>
   
        )
    }
}
/******************** Create Walls ********************/
const getNewGridWithWallToggled = (grid, row, col) => {
    // mouseDown starts to act strange if I don't make newGrid and work off of grid instead.
    const newGrid = grid.slice();
    const node = newGrid[row][col];
    if (!node.isStart && !node.isFinish && node.isNode) {
      const newNode = {
        ...node,
        isWall: !node.isWall,
      };
      newGrid[row][col] = newNode;
    }
    return newGrid;
  };
  
  // Backtracks from the finishNode to find the shortest path.
  // Only works when called after the pathfinding methods.
  function getNodesInShortestPathOrder(finishNode) {
    const nodesInShortestPathOrder = [];
    let currentNode = finishNode;
    while (currentNode !== null) {
      nodesInShortestPathOrder.unshift(currentNode);
      currentNode = currentNode.previousNode;
    }
    return nodesInShortestPathOrder;
  }
  
